export const patientInfo = [
  { label: 'MR#', value: '22351684' },
  { label: 'Patient', value: 'Philip, Cammiee John' },
  { label: 'DOB', value: '05/12/1998 (28 yrs)' },
  { label: 'Sex', value: 'Female' },
  { label: 'Phone', value: '(415) 555-1021' },
  { label: 'Insurance', value: 'Star Health' }
];

export const selectedPatient = {
  lastName: 'Philip',
  firstName: 'Cammiee John',
  countryCode: '1',
  mobile: '555-1021',
  email: '',
  confirmEmail: ''
};